<template>
  <b-overlay
    :show="loader"
    opacity="0.50"
    rounded="sm"
  >
    <div>
      <section>
        <b-row>
          <b-col
            cols="12"
            class="d-flex justify-content-center"
          >
            <b-card class="w-100 p-0">

              <selectplan
                class="mb-2"
                @selectedplan="idplan=$event"
              />
              <b-button
                v-if="idplan"
                variant="primary"
                class="mb-2"
                @click="abrirAgregar"
              >
                <b>Agregar</b>
              </b-button>

              <h5 v-if="fetchData.actual && fetchData.actual.length > 0">
                En Curso
              </h5>
              <p v-else-if="fetchData.actual && fetchData.actual.length === 0">
                No se está mostrando ninguna aportacion para este plan de estudios, agrega una nueva aportación.
              </p>
              <!-- aportacion -->
              <b-list-group class="mt-2 recursos-list">
                <b-list-group-item
                  v-for="(aportacion, index) in fetchData.actual"
                  :key="index"
                  class="recurso-item"
                >
                  <div class="recurso-row">
                    <feather-icon
                      icon="HexagonIcon"
                      class="text-primary"
                    />
                    {{ aportacion.concepto.concepto }}
                  </div>
                  <div class="recurso-row">
                    <feather-icon
                      icon="DollarSignIcon"
                      class="text-success"
                    />
                    {{ aportacion.monto }}
                  </div>
                  <div class="recurso-row">
                    <feather-icon
                      icon="CalendarIcon"
                      class="text-warning"
                    />
                    {{ aportacion.fecha_inicio_f }}
                  </div>
                  <div class="recurso-row">
                    <feather-icon
                      icon="CalendarIcon"
                      class="text-info"
                    />
                    {{ aportacion.fecha_fin_f }}

                  </div>
                  <div class="recurso-row">
                    <feather-icon
                      icon="MessageCircleIcon"
                    />
                    {{ aportacion.comentarios || '' }}
                  </div>

                  <div class="recurso-row">
                    <feather-icon
                      icon="UserIcon"
                    />
                    Editdo por: {{ aportacion.nombre || '' }}
                  </div>

                  <b-button
                    variant="primary"
                    class="mb-2"
                    @click="abrirEditar(aportacion)"
                  >
                    <b>Editar</b>
                  </b-button>
                </b-list-group-item>
              </b-list-group>

              <lista-historial-costos
                v-if="idplan"
                :idplan="idplan"
              />

            </b-card>
          </b-col>
        </b-row>
      </section>
      <!-- Modal agregar/editar aportacion -->
      <b-modal
        id="modal-costos"
        ref="modal-costos"
        scrollable
        :title="modoEdicion ? 'Editar aportación' : 'Agregar aportación'"
        size="lg"
        no-close-on-backdrop
        centered
        hide-footer
      >
        <ModalForm
          :aportacion="aportacionSeleccionada"
          :modo-edicion="modoEdicion"
          :idplan="idplan"
          @guardado="getDatos(idplan)"
        />
      </b-modal>
    </div>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BCard,
  BOverlay, BListGroupItem, BListGroup, BModal, BButton, VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  watch, ref, getCurrentInstance,
} from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getData } from '@core/utils/http/general'
import selectplan from '@/views/components/select-plan.vue'
import ModalForm from '@/views/campus/costos/ModalForm.vue'
import ListaHistorialCostos from '@/views/campus/costos/ListaHistorialCostos.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BModal,
    BOverlay,
    BListGroupItem,
    BListGroup,
    selectplan,
    ModalForm,
    BButton,
    ListaHistorialCostos,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  setup() {
    const loader = ref(false)
    const fetchData = ref([])
    const toast = useToast()
    const idplan = ref(null)
    const aportacionSeleccionada = ref(null)
    const modoEdicion = ref(false)
    const vm = getCurrentInstance().proxy

    const getDatos = q => {
      loader.value = true
      getData({ action: 11, token: store.state.cuenta.session.token, q }, 'wsplanEstudios')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) fetchData.value = response.data
          else {
            toast({
              component: ToastificationContent,
              props: {
                title: `${response.data.status} - Sección en construcción`,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
        }).catch(err => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error, No hay conexión',
              text: err,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        }).finally(() => {
          loader.value = false
        })
    }

    const abrirAgregar = () => {
      modoEdicion.value = false
      aportacionSeleccionada.value = null
      vm.$bvModal.show('modal-costos')
    }

    const abrirEditar = aportacion => {
      modoEdicion.value = true
      aportacionSeleccionada.value = { ...aportacion }
      vm.$bvModal.show('modal-costos')
    }

    watch(() => idplan.value, value => {
      fetchData.value = []
      getDatos(value)
    })
    return {
      fetchData,
      loader,
      idplan,

      // Funciones
      abrirAgregar,
      abrirEditar,
      getDatos,
      aportacionSeleccionada,
      modoEdicion,
    }
  },
}
</script>

<style scoped>

/* Recursos */
.recursos-list {
  border-left: 3px solid #adadad;
  margin-left: 0.5rem;
}

.recurso-item {
  border: none;
  background: #f7f7f7;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  padding: 0.75rem;
}

.recurso-row {
  font-size: 0.85rem;
  color: #000000;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

  </style>
